// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { mergeStyles } from '@fluentui/react';
/**
 * @private
 */
export const sidePaneContainerStyles = {
    root: {
        height: '100%',
        padding: '0.5rem 0.25rem',
        width: '21.5rem'
    }
};
/**
 * @private
 */
export const sidePaneContainerHiddenStyles = {
    root: Object.assign(Object.assign({}, sidePaneContainerStyles), { display: 'none' })
};
/**
 * @private
 */
export const sidePaneContainerTokens = {
    childrenGap: '0.5rem'
};
/**
 * @private
 */
export const sidePaneHeaderStyles = {
    root: {
        lineHeight: '1.25rem',
        padding: '0.25rem',
        fontWeight: '600'
    }
};
/**
 * @private
 */
export const sidePaneHeaderContainerStyles = {
    root: {
        margin: '0 0.25rem'
    }
};
/**
 * @private
 */
export const paneBodyContainer = {
    root: {
        flexDirection: 'column',
        display: 'flex'
    }
};
/**
 * @private
 */
export const scrollableContainer = {
    root: {
        flexBasis: '0',
        flexGrow: '1',
        overflowY: 'auto'
    }
};
/**
 * @private
 */
export const scrollableContainerContents = {
    root: {
        flexGrow: '1',
        flexBasis: '0',
        maxWidth: '100%',
        // Create a new stacking context so that `pipStyles` can set zIndex above the container.
        position: 'relative'
    }
};
/**
 * @private
 */
export const peopleSubheadingStyle = {
    root: {
        fontSize: '0.75rem'
    }
};
/**
 * @private
 */
export const peoplePaneContainerTokens = {
    childrenGap: '0.5rem'
};
/**
 * @private
 */
export const participantListWrapper = mergeStyles({
    width: '20rem',
    // max width at 50% of view so the People Pane is not squeezing the Message Pane to almost nothing when on small screen or high zoom in
    maxWidth: '50vw',
    height: '100%'
});
/**
 * @private
 */
export const participantListContainerPadding = {
    childrenGap: '0.5rem'
};
/**
 * @private
 */
export const participantListStack = mergeStyles({
    height: '100%'
});
/**
 * @private
 */
export const participantListContainerStyle = mergeStyles({
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden'
});
/**
 * @private
 */
export const participantListStyle = {
    root: {
        padding: '0rem'
    },
    participantItemStyles: {
        root: {
            padding: '0.5rem'
        }
    }
};
/**
 * @private
 */
export const participantListMobileStyle = {
    root: {
        padding: '0rem'
    },
    participantItemStyles: {
        root: {
            padding: '0.5rem 1rem'
        }
    }
};
//# sourceMappingURL=ParticipantContainer.styles.js.map